import { z } from "zod";
import { PauseKindSchema, ToneSchema } from "./cues";
import { BlockIdSchema, NodeIdSchema } from "./ids";
import { VoiceRoleSchema } from "./states";

/**
 * The unit of one ElevenLabs request (CONTEXT.md "Block"). `nodeIds` is what
 * aligns Review; a node that refined to nothing still appears in the previous
 * Block's ids, so every source node stays accounted for.
 */
export const BlockSchema = z.strictObject({
  id: BlockIdSchema,
  /** 0-based position in the script. */
  index: z.int().nonnegative(),
  nodeIds: z.array(NodeIdSchema).min(1),
  text: z.string(),
  pauseAfter: PauseKindSchema,
  tone: ToneSchema.nullable(),
  voiceRole: VoiceRoleSchema,
  /** Code points of `text`; what the Estimate bills. */
  characterCount: z.int().nonnegative(),
  editedByAuthor: z.boolean(),
});
export type Block = z.infer<typeof BlockSchema>;
